function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h14v14H0z",
    fill: "#fff",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 0H0v14h14zm-1.4 12.6H1.4V1.4h11.2z",
    fill: "#fff",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)",
    fill: "#355C72"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-.153 10.719a3.434 3.434 0 0 0 3.434 3.434h7.438a3.434 3.434 0 0 0 3.434-3.434V6.118a3.44 3.44 0 0 0-1.342-2.737.7.7 0 1 0-.849 1.113c.5.38.791.982.791 1.624v4.6c0 1.124-.91 2.035-2.034 2.035H3.28a2.034 2.034 0 0 1-2.034-2.034V6.118c0-.635.296-1.233.8-1.618l3.72-2.836a2.034 2.034 0 0 1 2.467 0l2.06 1.57a.7.7 0 0 0 1.125-.557V.875a.7.7 0 1 0-1.4 0v.389L9.083.55a3.435 3.435 0 0 0-4.166 0L1.198 3.387a3.43 3.43 0 0 0-1.351 2.73z",
    style: {
      fill: "#355c72",
      fill: "color(display-p3 .2078 .3608 .4471)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.906 6.316a.684.684 0 1 0 0 1.368.684.684 0 0 0 0-1.368m2.188 0a.684.684 0 1 0 0 1.368.684.684 0 0 0 0-1.368M5.906 8.504a.684.684 0 1 0 0 1.367.684.684 0 0 0 0-1.367m2.188 0a.684.684 0 1 0 0 1.367.684.684 0 0 0 0-1.367",
    style: {
      fill: "#355c72",
      fill: "color(display-p3 .2078 .3608 .4471)",
      fillOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHome);
export default __webpack_public_path__ + "static/media/ic_home.08a8133fd24bead39a5f895fd0302e6e.svg";
export { ForwardRef as ReactComponent };